import {
    Children,
    cloneElement,
    Fragment,
    isValidElement,
    type ReactElement,
    type ReactNode,
} from 'react';

/**
 * React 19 Children.toArray does not flatten Fragments; slots often use <> in ternaries.
 * Children of a Fragment are keyed under the Fragment's key so sibling groups stay distinct.
 */
export function flattenChildren(children: ReactNode, keyPrefix = ''): ReactNode[] {
    return Children.toArray(children).flatMap((child) => {
        if (!isValidElement(child)) {
            return child ? [child] : [];
        }
        if (child.type === Fragment) {
            return flattenChildren(
                (child as ReactElement<{ children?: ReactNode }>).props.children,
                `${keyPrefix}${child.key}/`,
            );
        }
        return [keyPrefix ? cloneElement(child, { key: `${keyPrefix}${child.key}` }) : child];
    });
}
